var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{mark: true, practice: _vm.type == 'practice', exam: _vm.type == 'exam'}},[_c('div',{staticClass:"wrap"},[_c('span',[_vm._v(_vm._s(_vm._f("tutorialType")(_vm.type)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }